import { FieldRenderProps } from 'react-final-form'
import Dropdown from '../../control/Dropdown'

type DropdownInputProps = FieldRenderProps<number, any>

const DropdownInput: React.FC<DropdownInputProps> = ({ input, meta, options, ...rest }) => {
    return <Dropdown {...input} {...rest} options={options} meta={meta} helperText={meta.error} />
}

export default DropdownInput
